import { derived } from 'svelte/store'

import { eduundertotalonly, eduUnderAct, eduUnderGpa, eduunderbyprog, eduundergender } from '../dataPromisesMenu'

import fetchStore from '../utilities/fetchStore'

const regex = /\$|\,/g

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    eduundertotalonly: eduundertotalonly,
    eduUnderAct: eduUnderAct,
    eduUnderGpa: eduUnderGpa,
    eduunderbyprog: eduunderbyprog,
    eduundergender: eduundergender,
  }
  
  const [data, loading, error] = fetchStore(dataCalls)

  const eduundertotalonlyDerived = derived(data, ($data)=>{

    if($data.eduundertotalonly) {
      return Object.values($data.eduundertotalonly)[0]
    } else {
      return 0
    }
  }, 0)

  const eduUnderActDerived = derived(data, ($data)=>{
    if($data.eduUnderAct) {
      return Object.entries($data.eduUnderAct)
    } else {
      return {}
    }
  }, {})

  const eduUnderGpaDerived = derived(data, ($data)=>{
    if($data.eduUnderGpa) {
      return Object.entries($data.eduUnderGpa)
    } else {
      return {}
    }
  }, {})
  
  const eduUnderByProgDerived = derived(data, ($data)=>{
    if($data.eduunderbyprog) {
      return Object.entries($data.eduunderbyprog)
    } else {
      return []
    }
  }, [])

  const eduUnderGenDerived = derived(data, ($data)=>{
    if($data.eduundergender) {
      return Object.entries($data.eduundergender)
    } else {
      return []
    }
  }, [])
  
  return [
    data, 
    loading, 
    error,

    eduundertotalonlyDerived,
    eduUnderActDerived,
    eduUnderGpaDerived,
    eduUnderByProgDerived,
    eduUnderGenDerived,
  ]
}